import axios from "axios";
import { CookieData, createCookieDate, JTCookies } from "../utils/storage/cookies";
import { addMinutes } from "date-fns";

const BASE_URL = process.env.REACT_APP_API_URL;

export const instance = (sendByForm) => {
  const base = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 150000,
    headers: {
      ...(sendByForm ? {
        "Content-Type": "multipart/form-data",
      }:{
        "Content-Type": "application/json",
      }),
      withCredentials: true,
    },
  });

  const methods = ["post", "patch", "put"];
  base.interceptors.request.use(async (config) => {
    const cookies = new JTCookies(document);
    const token = await cookies.getCookie("authAdToken").catch(() => null);
    if (token) {
      config.headers = {
        "Content-Type": "application/json",
        ...config.headers,
        withCredentials: true,
        Authorization: `Bearer ${token}`,
      };
    }
    return config;
  });

  base.interceptors.response.use((config) => {
    if (methods.includes(config.config.method)) {
      const cookies = new JTCookies(document);
      const data = config.data?.data;
      try {
        console.log(data?.token, "TOKEN TOKEN");
        if (data?.token) {
          const authCookie = new CookieData(
            "authAdToken",
            data["token"],
            createCookieDate(data["expiresIn"])
          );
          const emailCookie = new CookieData(
            "email",
            data["email"],
            createCookieDate(data["expiresIn"])
          );
          const timeCookie = new CookieData(
            "expiryDate",
            addMinutes(new Date(), 10).toISOString(),
            createCookieDate(data["expiresIn"])
          );
          console.log(timeCookie);
          cookies.saveCookies([authCookie, emailCookie, timeCookie]);
        }
      } catch (error) {
        console.log(error);
      }
    }
    return config;
  }, (error) => {
    // the admin's session is no longer valid (expired token, or account
    // deactivated/deleted): sign out and go back to the login screen
    const status = error?.response?.status;
    if ((status === 401 || status === 403) && error.response.data?.auth === false) {
      signOut(error.response.data?.message);
    }
    return Promise.reject(error);
  });

  return base;
};

let signingOut = false;
function signOut(message) {
  if (signingOut) return;
  signingOut = true;
  const cookies = new JTCookies(document);
  ["authAdToken", "email", "expiryDate"].forEach((name) => cookies.removeCookie(name));
  try {
    localStorage.removeItem("permissions");
    if (message) sessionStorage.setItem("signedOutReason", message);
  } catch (e) {}
  window.location.assign("/");
}

export const next = (e) => {
  throw new Error(
    e.response?.data ? e.response.data.message : "Something went wrong"
  );
};

export { BASE_URL as baseUrl };
